import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { generalService } from '../../../services/general.service';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { DataService } from '../../../utils/data.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-conciliacion-bancaria-det',
  templateUrl: './conciliacion-bancaria-det.component.html',
  styleUrls: ['./conciliacion-bancaria-det.component.scss'],
  providers: [generalService]
})
export class ConciliacionBancariaDetComponent implements OnInit {

  @ViewChild(MatSort) sortEgresos: MatSort;
  @ViewChild(MatSort) sortIngresos: MatSort;
  @ViewChild('paginatorEgresos') paginatorEgresos: MatPaginator;
  @ViewChild('paginatorIngresos') paginatorIngresos: MatPaginator;
  @ViewChild('tableBalanceGeneral') tableBalanceGeneral: ElementRef;
  // dataSourceEgresos: DataSourceGrid | MatTableDataSource<any> | null = null;
  dataSourceEgresos: MatTableDataSource<any> = new MatTableDataSource([]);
  // dataSourceIngresos: DataSourceGrid | MatTableDataSource<any> | null = null;
  dataSourceIngresos: MatTableDataSource<any> = new MatTableDataSource([]);
  private dataSourceEgresosSubscription: any; // Subscripción a los cambios del DataSource
  private dataSourceIngresosSubscription: Subscription; // Subscripción a los cambios del DataSource
  formCoinciliacion: FormGroup;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idUsuario: any = this.userData.USER_ID;
  public idCompania: any = this.userData.COMPANY_ID;
  cuentaBancariaOptions:{ BANK_ACCOUNT_ID: number, NAME: string }[] = [];
  public listBankAccount: any[] = [];
  filter:{
          cuentaBancaria:number
          ,fechaCoinciliacion:Date
          ,saldoCuentaBancaria: number
          ,fechaUltimaCoinciliacion:Date
          ,egresosEnTransito:number
          ,ingresosEntransito:number
          ,saldoContabilidad:number
          ,diferencia:number
        }=
    {
      cuentaBancaria: 0
      ,fechaCoinciliacion: undefined
      ,saldoCuentaBancaria: 0
      ,fechaUltimaCoinciliacion: undefined
      ,egresosEnTransito:0
      ,ingresosEntransito:0
      ,saldoContabilidad:0
      ,diferencia:0
    };
  fechaInicioOptions: { id: number, name: string }[] = [];
  public dataBalanceGeneralActivos: any[] = [];
  public dataBalanceGeneralPasivoCapital: any[] = [];
  public filteredDataNivel: any[] = [];
  public filteredDataNivel2: any[] = [];
  public balanceGeneralExcel: any[] = [];
  combinedData: any[] = [];
  public nivel = 0;
  public fechaExcel;
  public totalSaldoActivo = 0;
  public totalSaldoPasivosCapital = 0;
  // displayedColumnsEgresos = ["acciones","fecha","concepto","importe","tipo",'NUMEROCUENTA', 'NOMBRE', 'SALDO'];
  // displayedColumnsIngresos = ["acciones","fecha","concepto","importe","tipo",'NUMEROCUENTA2', 'NOMBRE2', 'SALDO2'];
  displayedColumnsEgresos = ["acciones","fecha","concepto","importe","referencia"];
  displayedColumnsIngresos = ["acciones","fecha","concepto","importe","referencia"];
  filteredData: any[] = [];
 filteredDataRANGE_3: any[] = [];
  
  BANK_CONCILIATION_ID:number = null;
  BANK_CONCILIATION_NUMBER:string = "20240827-00000";
  statusCoinciliacion:number = null;
  cerrarCoinciliacion:boolean=false;
  
  constructor(private formBuilder: FormBuilder,private _generalService: generalService,public dataService: DataService,private route: ActivatedRoute,) { 
    this.generateFechaInicioOptions();
  }

  ngOnInit() {
    this.buildForm();
    // this.getDataFilters();
    this.getOptions();

    // this.formFilter.valueChanges.subscribe((formValues) => {
    
    // });
    this.determinarNuevaCoincilacion();
    this.iniciarSuscripcionAFormulario();
  }
  ngOnDestroy(): void {
    // Cancela la suscripción cuando el componente es destruido
    
  }
  iniciarSuscripcionAFormulario() {
    // Suscribirse ala cuenta bancaria
    this.formCoinciliacion.get('idCuentaBancaria')?.valueChanges.subscribe((nuevoValor) => {
      let fechaCoinciliacion = this.formCoinciliacion.get('fechaCoinciliacion').value;
      
      if(nuevoValor && fechaCoinciliacion && !this.BANK_CONCILIATION_ID)
      {
        this.getDatosParaNuevaCoincilacion();
        
      }
    });

    this.formCoinciliacion.get('fechaCoinciliacion')?.valueChanges.subscribe((nuevoValor) => {
      let idCuentaBancaria = this.formCoinciliacion.get('idCuentaBancaria').value;
      if(nuevoValor && idCuentaBancaria && !this.BANK_CONCILIATION_ID)
      {
        this.getDatosParaNuevaCoincilacion();
      }
    });

    this.formCoinciliacion.get('ingresosEnTransito')?.valueChanges.subscribe((nuevoValor:number) => {
      if(nuevoValor>=0)
      {
        this.calcularDiferencia();
      }
    });

    this.formCoinciliacion.get('egresosEnTransito')?.valueChanges.subscribe((nuevoValor:number) => {
      if(nuevoValor>=0)
      {
        this.calcularDiferencia();
      }
    });

    this.formCoinciliacion.get('saldoCuentaBancaria')?.valueChanges.subscribe((nuevoValor:number) => {
      if(Number(nuevoValor))
      {
        if(nuevoValor>=0)
          {
          this.calcularDiferencia();
        }
      }
      
    });


  }
  
  determinarNuevaCoincilacion()
  {
    this.route.params.subscribe(params => {
      let BANK_CONCILIATION_ID_PARAMS = params['id'];
      if(Number(BANK_CONCILIATION_ID_PARAMS))
      {
          this.BANK_CONCILIATION_ID=params['id'];
          this.getCoinciliacionBancaria();
      }
      else
      {
        let fechaString=moment().format('YYYYMMDD');;
        let coinciliacionNumber="00000";
        this.BANK_CONCILIATION_NUMBER=`${fechaString} - ${coinciliacionNumber}`;
      }
    });
  }
  getDatosParaNuevaCoincilacion(){
    

    let metodo = 'ConciliacionBancaria/getDataForNewCoinciliacion';
    const params = { 
        loacs: sessionStorage.getItem('acslo'),
        BANK_ACCOUNT_ID: this.formCoinciliacion.get('idCuentaBancaria').value
        ,fechaCoinciliacion:this.formCoinciliacion.get('fechaCoinciliacion').value
    };

    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        const dataCoinciliacionResponse = JSON.parse(result);
        const dataCoinciliacion = dataCoinciliacionResponse[0];
        this.formCoinciliacion.get('fechaUltimaCoinciliacion').setValue(dataCoinciliacion.lastFechaCoinciliacion);
        this.formCoinciliacion.get('saldoContabilidad').setValue(dataCoinciliacion.saldoFinal);
        this.getMovimientosParaCoinciliacion();
      },
      error => {  console.log(<any>error);  }
    );
  }
  getMovimientosParaCoinciliacion(){


    let metodo = 'ConciliacionBancaria/getMovimientosParaCoinciliacion';
    const params = { 
        // loacs: sessionStorage.getItem('acslo'),
        fechaCoinciliacion: this.formCoinciliacion.get('fechaCoinciliacion').value,
        BANK_ACCOUNT_ID : this.formCoinciliacion.get('idCuentaBancaria').value
    };

    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        const dataCoinciliacionResponse = JSON.parse(result);
        const dataCoinciliacion = dataCoinciliacionResponse[0];
        
        this.dataSourceEgresos = new MatTableDataSource(dataCoinciliacionResponse.Table);
        // this.dataSourceIngresos = new DataSourceGrid(dataCoinciliacionResponse.Table1, this.paginatorIngresos, this.sortIngresos);
        this.dataSourceIngresos = new MatTableDataSource(dataCoinciliacionResponse.Table1);


        this.dataSourceIngresos.paginator=this.paginatorIngresos;
        this.dataSourceIngresos.sort=this.sortIngresos;

        // Hacemos la sumatoria
        const totalEgresos = dataCoinciliacionResponse.Table.reduce((accumulator, currentItem) => {
          return accumulator + currentItem.importe;
        }, 0);
        const totalIgresos = dataCoinciliacionResponse.Table1.reduce((accumulator, currentItem) => {
          return accumulator + currentItem.importe;
        }, 0);

        this.formCoinciliacion.get("egresosEnTransito").setValue(totalEgresos);
        this.formCoinciliacion.get("ingresosEnTransito").setValue(totalIgresos);

      },
      error => {  console.log(<any>error);  }
    );
  }
  buildForm(){
    const startMonthYear = this.fechaInicioOptions[0].id;
    this.formCoinciliacion = this.formBuilder.group({
      idCuentaBancaria: [null, Validators.required],
      fechaCoinciliacion: [null, Validators.required],
      saldoCuentaBancaria: new FormControl({ value: 0}),
      fechaUltimaCoinciliacion: new FormControl({ value: null, disabled: true }),
      egresosEnTransito:  new FormControl({ value: 0, disabled: true }),
      ingresosEnTransito: new FormControl({ value: 0, disabled: true }),
      saldoContabilidad: new FormControl({ value: 0, disabled: true }),
      diferencia: new FormControl({ value: 0, disabled: true }),
      cerrarCoinciliacion: new FormControl({ value: false, disabled: false }),
    });
  }
  validarCoinciliacion():boolean
  {
    
    let ultimaFechaCoinciliacion =this.formCoinciliacion.get("fechaUltimaCoinciliacion").value
    if(ultimaFechaCoinciliacion)
    {
      let ultimaFechaCoinciliacionMoment = moment(ultimaFechaCoinciliacion);
      let fechaCoinciliacion = moment(this.formCoinciliacion.get("fechaCoinciliacion").value);
      if(fechaCoinciliacion.isAfter(ultimaFechaCoinciliacionMoment))
      {

        return true;
      }
      else
      {
        this._generalService.toastCall("La fecha coinciliación debe ser mayor ala ultima fecha coinciliación");
        return false;
      }
    }
    else
    {
      return true;
    }
  }
  guardarCoinciliacion() {
    if(!this.validarCoinciliacion())
    {
      return;
    }
    let params:any={};
    params.BANK_CONCILIATION_ID=this.BANK_CONCILIATION_ID ?? null;
    params.BANK_ACCOUNT_ID=this.formCoinciliacion.get("idCuentaBancaria").value;
    params.LAST_CONCILIATION_DATE=this.formCoinciliacion.get("fechaUltimaCoinciliacion").value;
    params.CONCILIATION_DATE=this.formCoinciliacion.get("fechaCoinciliacion").value;
    params.CONCILIATION_BALANCE =this.formCoinciliacion.get("saldoCuentaBancaria").value;// Saldo Cuenta bancaria
    params.EXPENDITURE_IN_TRANSIT =this.formCoinciliacion.get("egresosEnTransito").value;// Esta es egresos
    params.INCOME_IN_TRANSIT =this.formCoinciliacion.get("ingresosEnTransito").value;// Esta es egresos
    params.ACCOUNTING_BALANCE =this.formCoinciliacion.get("saldoContabilidad").value;// Saldo Contabilidad
    params.CREATION_BY = this.idUsuario;
    params.DIFFERENCE = this.formCoinciliacion.get("diferencia").value;
    params.cerrarCoinciliacion= this.formCoinciliacion.get("cerrarCoinciliacion").value;
    params.COMPANY_ID =this.idCompania;
    params.cuentas=[];
    for (let egreso of this.dataSourceEgresos.data) 
    {
      params.cuentas.push({POLIZA_DETAIL_ID:egreso.POLIZA_DETAIL_ID,CONCILIATED:egreso.CONCILIATED});
    }

    for (let ingreso of this.dataSourceIngresos.data) 
    {
      params.cuentas.push({POLIZA_DETAIL_ID:ingreso.POLIZA_DETAIL_ID,CONCILIATED:ingreso.CONCILIATED});
    }

    let metodo = 'ConciliacionBancaria/guardarCoinciliacion';
   
    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        var resultParseado = JSON.parse(result);
        
        this.BANK_CONCILIATION_ID=Number(resultParseado.BANK_CONCILIATION_ID);
        let msjCerrada="y Cerrada";
        if(!params.cerrarCoinciliacion)
        {
          msjCerrada="";
        }
        this._generalService.toastCall("Coinciliación Bancaria Guardada " + msjCerrada);
        this.getCoinciliacionBancaria();
      },
      error => {  console.log(<any>error);  }
    );

  
  }
  getCoinciliacionBancaria()
  {
    let params:any={};
    params.BANK_CONCILIATION_ID = this.BANK_CONCILIATION_ID;
    let metodo = 'ConciliacionBancaria/getCoinciliacion';
    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        const resultadoParseado= JSON.parse(result);
        this.cargarCoiniciliacion(resultadoParseado);
        console.log(resultadoParseado);

      },
      error => {  console.log(<any>error);  }
    );
  }
  cargarCoiniciliacion(data:any)
  {
    let coinciliacionGeneral = data.Table[0];
    this.formCoinciliacion.patchValue
    ({
      idCuentaBancaria          :coinciliacionGeneral.BANK_ACCOUNT_ID
      ,fechaCoinciliacion       :coinciliacionGeneral.CONCILIATION_DATE
      ,saldoCuentaBancaria      :coinciliacionGeneral.CONCILIATION_BALANCE
      ,fechaUltimaCoinciliacion :coinciliacionGeneral.LAST_CONCILIATION_DATE
      ,egresosEnTransito        :coinciliacionGeneral.EXPENDITURE_IN_TRANSIT
      ,ingresosEnTransito       :coinciliacionGeneral.INCOME_IN_TRANSIT
      ,saldoContabilidad        :coinciliacionGeneral.ACCOUNTING_BALANCE
      ,diferencia               :coinciliacionGeneral.DIFFERENCE
    });
    this.formCoinciliacion.get('idCuentaBancaria')?.disable();
    this.formCoinciliacion.get('fechaCoinciliacion')?.disable();
    this.statusCoinciliacion=coinciliacionGeneral.STATUS;

    if([1,2].includes(this.statusCoinciliacion))
    {
      this.formCoinciliacion.get('saldoCuentaBancaria')?.disable();
    }
    this.BANK_CONCILIATION_ID=coinciliacionGeneral.BANK_CONCILIATION_ID;
    this.BANK_CONCILIATION_NUMBER=coinciliacionGeneral.CONCILIATION_NUMBER;
    // Hay que poner el numero de coiniciliacion
    let tableEgresos=data.Table1;
    let tableIngresos=data.Table2;

    this.dataSourceEgresos = new MatTableDataSource(tableEgresos);
    // this.dataSourceIngresos = new DataSourceGrid(dataCoinciliacionResponse.Table1, this.paginatorIngresos, this.sortIngresos);
    this.dataSourceIngresos = new MatTableDataSource(tableIngresos);

    // const totalEgresos = tableEgresos.Table.reduce((accumulator, currentItem) => {
    //   return accumulator + currentItem.importe;
    // }, 0);
    // const totalIgresos = tableIngresos.Table.Table1((accumulator, currentItem) => {
    //   return accumulator + currentItem.importe;
    // }, 0);

    // this.formCoinciliacion.get("egresosEnTransito").setValue(totalEgresos);
    // this.formCoinciliacion.get("ingresosEnTransito").setValue(totalIgresos);

  }
  toggleCerrarCoinciliacion()
  {
    console.log(this.formCoinciliacion);
  }
  toggleCoinciliar(mov:any)
  {
    this.calcularIngresos();
    this.calcularEgresos();
  }
  getOptions()
  {
    this.getDataBankAccount();
  }
  getDataBankAccount(){
    let metodo = 'ConciliacionBancaria/getDataBankAccount';
    const params = { 
        loacs: sessionStorage.getItem('acslo'),
    };

    this._generalService.metodoCallParams(params, metodo, true).subscribe(
        (result) => {
            const tableResult = JSON.parse(result);
            if (tableResult && tableResult.Table) {
                this.listBankAccount = tableResult.Table;
                this.cuentaBancariaOptions=tableResult.Table;
            }
        }, 
        (error) => {
            console.log(error as any);
        }
    );
}
calcularEgresos()
{
    var totalEgresos:number=0;
    for (let egreso of this.dataSourceEgresos.data) 
    {
      if(!egreso.CONCILIATED)
      {
        totalEgresos+=egreso.importe;
      }
    }
      this.formCoinciliacion.get("egresosEnTransito").setValue(totalEgresos);
}
calcularIngresos()
{
    var totalIngresos:number=0;
    for (let ingreso of this.dataSourceIngresos.data) 
    {
      if(!ingreso.CONCILIATED)
      {
        totalIngresos+=ingreso.importe;
      }
    }
      this.formCoinciliacion.get("ingresosEnTransito").setValue(totalIngresos);
}

calcularDiferencia()
{
    var totalDiferencia:number=0;

    let saldoCuentaBancaria = Number(this.formCoinciliacion.get("saldoCuentaBancaria").value);
    
    if(saldoCuentaBancaria)
      totalDiferencia=saldoCuentaBancaria;
    else
      totalDiferencia=0;

    totalDiferencia-=this.formCoinciliacion.get("saldoContabilidad").value;

    totalDiferencia-=this.formCoinciliacion.get("ingresosEnTransito").value;
    totalDiferencia+=this.formCoinciliacion.get("egresosEnTransito").value;
      this.formCoinciliacion.get("diferencia").setValue(totalDiferencia);
}
cancelarSolicitud()
{
    
  let params:any={};
  // params.BANK_CONCILIATION_ID=this.BANK_CONCILIATION_ID ?? null;
  params.BANK_CONCILIATION_ID= this.BANK_CONCILIATION_ID;
  params.idUsuario = this.idUsuario;
  let metodo = 'ConciliacionBancaria/cancelarCoinciliacion';
 
  this._generalService.metodoCallParams(params, metodo, true).subscribe(
    result => {
      this._generalService.toastCall("Coinciliación Cerrada");
      this.getCoinciliacionBancaria();
    },
    error => {  console.log(<any>error);  }
  );

}
salir()
{
  
}
  generateFechaInicioOptions() {
    const currentDate = moment();
    for (let i = 0; i < 12; i++) {
      const date = currentDate.clone().subtract(i, 'months');
      this.fechaInicioOptions.push({
        id: parseInt(date.format('YYYYMM'), 10),
        name: date.format('MMMM YYYY')
      });
    }
  }
  
  
  structureData(data) {
    const result = [];
    const rangeTypeNames = [];
    let totalSaldoGeneral = 0; 
    let totalItemCount = 1;

    // Agrupar los datos por RANGE_TYPE_ID
    const groupedByRangeTypeId = data.reduce((acc, item) => {
        const { RANGE_TYPE_ID, RANGE_TYPE_NAME } = item;
        if (!acc[RANGE_TYPE_ID]) {
            acc[RANGE_TYPE_ID] = { RANGE_TYPE_NAME, items: [] };
        }
        acc[RANGE_TYPE_ID].items.push(item);
        return acc;
    }, {});

    // Iterar sobre cada grupo de RANGE_TYPE_ID
    Object.keys(groupedByRangeTypeId).forEach(rangeTypeId => {
        const rangeType = groupedByRangeTypeId[rangeTypeId];

        // Agregar el nombre del RANGE_TYPE a la lista de nombres
        rangeTypeNames.push(rangeType.RANGE_TYPE_NAME);

        // Crear el objeto rangeTypeItem con el nombre del RANGE_TYPE
        const rangeTypeItem = {
            RANGE_TYPE_ID: parseInt(rangeTypeId),
            type: 'RANGE_TYPE',
            name: rangeType.RANGE_TYPE_NAME.toUpperCase(),
            NIVEL: 0
        };

        // Agregar el rangeTypeItem al resultado
        result.push(rangeTypeItem);

        // Agrupar los datos dentro de cada RANGE_TYPE_ID por RANGE_ACCOUNT_ID
        const groupedByRangeAccountId = rangeType.items.reduce((acc, item) => {
            const { RANGE_ACCOUNT_ID, RANGE_ACCOUNT_DESCRIPTION } = item;
            if (!acc[RANGE_ACCOUNT_ID]) {
                acc[RANGE_ACCOUNT_ID] = {
                    RANGE_ACCOUNT_DESCRIPTION,
                    items: [],
                };
            }
            acc[RANGE_ACCOUNT_ID].items.push(item);
            return acc;
        }, {});

        // Agregar los RANGE_ACCOUNT al resultado y sumar los saldos iniciales al RANGE_TYPE
        Object.keys(groupedByRangeAccountId).forEach(rangeAccountId => {
            const rangeAccount = groupedByRangeAccountId[rangeAccountId];

            const totalSaldo = rangeAccount.items.reduce((acc, item) => {
              if (item.NIVEL === 1) {
                  acc += (item.Saldo || 0); // Suma el saldo
              }
              return acc;
          }, 0);
          
          
          if (parseInt(rangeTypeId) === 1) {
            totalSaldoGeneral += totalSaldo;
          } 
           if (parseInt(rangeTypeId) === 2 ) {
            totalSaldoGeneral += totalSaldo;
            } else if (parseInt(rangeTypeId) === 3) {
            totalSaldoGeneral -= totalSaldo;
          } 
            

            // Crear el objeto rangeAccountItem con la descripción del RANGE_ACCOUNT y saldo total
            const rangeAccountItem = {
                RANGE_TYPE_ID: parseInt(rangeTypeId), // Asignar el RANGE_TYPE_ID
                RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
                RANGE_ACCOUNT_ID_index: parseInt(rangeAccountId),
                type: 'RANGE_ACCOUNT',
                name: rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
                saldoTotal_RANGE_ACCOUNT: totalSaldo,
                NIVEL: 0
            };

            result.push(rangeAccountItem); // Añadir rangeAccountItem al principio

            // Agregar las filas de datos regulares debajo del RANGE_ACCOUNT si hay datos
            if (rangeAccount.items.length > 0) {
                result.push(...rangeAccount.items);
            }

            // Añadir el total como un nuevo objeto al final del grupo
            const totalItem = {
                RANGE_TYPE_ID: parseInt(rangeTypeId),
                RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
                type: 'Total_RANGE_ACCOUNT',
                nameTotal: 'Total '+rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
                saldoTotal_RANGE_ACCOUNT: totalSaldo,
                saldoTotalE_RANGE_ACCOUNT: totalSaldo,
                NIVEL: 0,
                NUMBER: '',
                NAME: '',
                
            };
            
            result.push(totalItem); // Añadir totalItem al final del grupo
        });
    });
    
    
    // Agregar la fila TOTAL al final del resultado
    const totalItem = {
        type: 'TOTAL',
        NIVEL: 0,
        NAME: '', // Para que no salga undefined en la tabla
        name_TotalGeneral: rangeTypeNames.join(', '), // Concatenar los nombres de RANGE_TYPE_NAME
        saldoTotal_GENERAL: totalSaldoGeneral, // Total de todos los saldos
        index : totalItemCount
    };
    
    result.push(totalItem);
    
    return result;
  }

  exportarExcel() {
    if (this.balanceGeneralExcel.length > 0) {
      // Filtra solo por RANGE_TYPE_ID === 1
      this.filteredData = this.balanceGeneralExcel.filter(item => item.RANGE_TYPE_ID === 1 || item.name_TotalGeneral === 'Activo');
      // Filtra por RANGE_TYPE_ID === 3 o 2
      this.filteredDataRANGE_3 = this.balanceGeneralExcel.filter(item => item.RANGE_TYPE_ID === 3 || item.RANGE_TYPE_ID === 2 || item.name_TotalGeneral === 'Pasivo, Capital'|| item.name_TotalGeneral === 'Pasivo - Capital');
      const filteredDataLength = Math.max(this.filteredData.length, this.filteredDataRANGE_3.length);
      const combinedData = [];
      //unimos this.filteredData y  this.filteredDataRANGE_3
      this.filteredDataRANGE_3.forEach(item => {
        // Verifica si el tipo es 'TOTAL' y el nombre es 'Pasivo, Capital'
        if (item.type === 'TOTAL' && item.name_TotalGeneral === 'Pasivo, Capital') {
            // Cambia el nombre a 'Pasivo - Capital'
            item.name_TotalGeneral = 'Pasivo - Capital';
        }
      });
      
      for (let i = 0; i < filteredDataLength; i++) {
        combinedData.push({
          data1: this.filteredData[i] || {}, 
          data2: this.filteredDataRANGE_3[i] || {} 
        });
      }

      this.combinedData = combinedData; 
      this.readyExport();
    }
  }

  readyExport() {
    const fechaInicio = this.fechaExcel; 
    const year = fechaInicio.substring(0, 4);
    const month = fechaInicio.substring(4);
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const monthName = monthNames[Number(month) - 1];
    const fechaExcelForm = monthName + ' ' + year;

    setTimeout(() => this.exportAsExcelFile("Balance General " + fechaExcelForm), 500);
  }

  exportAsExcelFile(filename: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableBalanceGeneral.nativeElement);
    const headersWorksheet = ['NUMERO DE CUENTA', 'NOMBRE', 'SALDO', 'ACTIVO', 'PASIVO', 'CAPITAL'];

   
    for (const z in worksheet) {
      if (z[0] === '!') continue; 

      const cell = worksheet[z];
      if (cell) {
        const col = z.replace(/[0-9]/g, ''); 

       
        if (headersWorksheet.indexOf(cell.v + '') > -1) {
          this.wrapAndCenterCell(cell, 'header'); 
        } else if (col === 'C') { 
          this.wrapAndCenterCell(cell, 'decimal'); 
        } else if (['F', 'G', 'H', 'I', 'L', 'M', 'N'].includes(col)) {
          this.wrapAndCenterCell(cell, 'decimal'); 
        } else if (col === 'O') {
          this.wrapAndCenterCell(cell, 'porcentaje'); 
        } else if (['D', 'H', 'K'].includes(col) && cell.t === 'n' && cell.z !== 'm/d/yy') {
          this.wrapAndCenterCell(cell, 'decimal'); 
        } else if (typeof cell.v === 'string' && cell.v.startsWith('$')) {
          this.wrapAndCenterCell(cell, 'decimal'); 
        }
      }
    }

   
    const workbook: XLSX.WorkBook = { Sheets: { General: worksheet }, SheetNames: ['General'] };
    const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });

    this.saveAsExcelFile(excelBuffer, filename);
  }
  
  saveAsExcelFile(buffer: any, filename: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(data, filename + '.xlsx');
  }

  wrapAndCenterCell(cell: XLSX.CellObject, tipo: string) {
    let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } }; 

    switch (tipo) {
      case 'header':
        cellStyle.font = { bold: true }; 
        break;
      case 'decimal':
        cellStyle.numFmt = '$#,##0.00'; 
        if (typeof cell.v === 'number' && cell.v < 0) {
          cellStyle.font = { color: { rgb: 'FF0000' } }; // Poner en rojo los valores negativos
        }
        break;
      case 'porcentaje':
        cellStyle.numFmt = '0.00%;\\(0.00%\\);\\-;@'; 
        break;
    }

    this.setCellStyle(cell, cellStyle); 
  }

  setCellStyle(cell: XLSX.CellObject, style: any) {
    cell.s = style;
  }  
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/conciliacionBancaria/conciliacion-bancaria-det/conciliacion-bancaria-det.component.ts